// Онбординг первого запуска: 3 шага — приветствие, выбор модулей, первое действие.
// Пишет hidden_tabs (существующая механика Профиля) и флаг onb_done_v1.
import { useState } from 'react';
import { useAuth } from '../context/AuthContext.jsx';
import { useSettings } from '../context/SettingsContext.jsx';
import { safeSet } from '../lib/storage.js';

const ACC = 'var(--app-accent,#c9a24b)';
const CARD = 'var(--app-card,#121216)';
const BORDER = 'var(--app-border,#1f1f25)';
const GOLDB = 'var(--app-border-gold,#2a2418)';

// Модули, которые можно включить/выключить (Сегодня и Заметки — всегда включены).
// Рынки сюда не входят: это борд на «Сегодня» (включается ⚙ на табло), а не раздел.
const MODULES = [ /* ru-data: фолбэки, рендер через t(key, fb) */
  { id: 'goals',     icon: '🎯', key: 'onb_m_goals',     fbT: 'Цели и фокус',  fbD: 'Таймер фокуса, цели, аналитика времени', def: true },
  { id: 'body',      icon: '🩺', key: 'onb_m_body',      fbT: 'Тело',          fbD: 'Сон, самочувствие, вес, тренировки',     def: true },
  { id: 'education', icon: '🧠', key: 'onb_m_edu',       fbT: 'Образование',      fbD: 'Свои конспекты, карточки и квизы',       def: false },
  { id: 'chat',      icon: '💬', key: 'onb_m_chat',      fbT: 'Общение',       fbD: 'Друзья и переписка',                     def: false },
];

export default function OnboardingFlow({ onDone, switchTab }) {
  const { apiFetch } = useAuth();
  const { t } = useSettings();
  const [step, setStep] = useState(0);
  const [sel, setSel] = useState(() => new Set(MODULES.filter(m => m.def).map(m => m.id)));

  const finish = (goTab) => {
    const hidden = MODULES.filter(m => !sel.has(m.id)).map(m => m.id);
    safeSet('hidden_tabs', JSON.stringify(hidden));
    safeSet('onb_done_v1', '1');
    // Пройденность — свойство аккаунта: пишем на сервер (fire-and-forget).
    try { apiFetch('/users/me', { method: 'PUT', body: JSON.stringify({ onboardingDone: true }) }); } catch {}
    window.dispatchEvent(new Event('hidden_tabs_changed'));
    onDone();
    if (goTab) switchTab(goTab);
  };

  const btn = { padding: '13px 16px', borderRadius: 12, border: `1px solid ${GOLDB}`, background: 'var(--app-accent-wash,#1a160c)', color: ACC, fontSize: 14, fontWeight: 700, cursor: 'pointer', width: '100%' };
  const ghost = { ...btn, border: '1px solid transparent', background: 'transparent', color: 'var(--app-dim,#8a8a92)', fontWeight: 500 };

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 300, background: 'var(--app-bg,#0d0d10)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 18 }}>
      <div style={{ width: '100%', maxWidth: 420 }}>
        {/* прогресс */}
        <div style={{ display: 'flex', gap: 6, marginBottom: 26, justifyContent: 'center' }}>
          {[0, 1, 2].map(i => <div key={i} style={{ width: 34, height: 3, borderRadius: 2, background: i <= step ? ACC : '#26262c' }} />)}
        </div>

        {step === 0 && (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 44, marginBottom: 14 }}>☀️</div>
            <div style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 30, color: 'var(--app-text,#ece6d6)', marginBottom: 10 }}>
              {t('onb_hello', 'Привет!')}
            </div>
            <div style={{ fontSize: 14, color: 'var(--app-dim,#8a8a92)', lineHeight: 1.55, marginBottom: 28 }}>
              {t('onb_tagline', 'Это твой личный помощник: он слушает тело, помогает фокусироваться на важном и показывает, куда уходит время.')}
            </div>
            <button onClick={() => setStep(1)} style={btn}>{t('onb_start', 'Настроить за минуту')} →</button>
          </div>
        )}

        {step === 1 && (
          <div>
            <div style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 24, color: 'var(--app-text,#ece6d6)', marginBottom: 6, textAlign: 'center' }}>
              {t('onb_pick_title', 'Что тебе нужно?')}
            </div>
            <div style={{ fontSize: 12, color: 'var(--app-dim,#8a8a92)', marginBottom: 18, textAlign: 'center' }}>
              {t('onb_pick_sub', 'Выбери разделы — остальное всегда можно включить в Профиле.')}
            </div>
            {MODULES.map(m => {
              const on = sel.has(m.id);
              return (
                <div key={m.id} onClick={() => setSel(p => { const n = new Set(p); if (n.has(m.id)) n.delete(m.id); else n.add(m.id); return n; })}
                     style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 14px', marginBottom: 8, borderRadius: 12, cursor: 'pointer',
                              background: CARD, border: `1px solid ${on ? GOLDB : BORDER}` }}>
                  <span style={{ fontSize: 22 }}>{m.icon}</span>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 14, fontWeight: 700, color: on ? ACC : 'var(--app-text,#ece6d6)' }}>{t(m.key, m.fbT)}</div>
                    <div style={{ fontSize: 11, color: 'var(--app-dim,#8a8a92)' }}>{t(m.key + '_d', m.fbD)}</div>
                  </div>
                  <div style={{ width: 22, height: 22, borderRadius: 7, border: `2px solid ${on ? ACC : '#33333a'}`, background: on ? ACC : 'transparent',
                                display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#0d0d10', fontSize: 13, fontWeight: 900 }}>{on ? '✓' : ''}</div>
                </div>
              );
            })}
            <div style={{ fontSize: 10.5, color: 'var(--app-dimmer,#5a5a62)', margin: '4px 0 14px', textAlign: 'center' }}>
              ☀️ {t('onb_always', 'Сегодня и Заметки (заметки, идеи, вишлист) включены всегда')}
            </div>
            <button onClick={() => setStep(2)} style={btn}>{t('onb_next', 'Дальше')} →</button>
          </div>
        )}

        {step === 2 && (
          <div>
            <div style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 24, color: 'var(--app-text,#ece6d6)', marginBottom: 6, textAlign: 'center' }}>
              {t('onb_first_title', 'С чего начнём?')}
            </div>
            <div style={{ fontSize: 12, color: 'var(--app-dim,#8a8a92)', marginBottom: 18, textAlign: 'center' }}>
              {t('onb_first_sub', 'Одно маленькое действие — и приложение уже работает на тебя.')}
            </div>
            {[ /* ru-data */
              sel.has('goals') && { icon: '▶', k: 'onb_a_focus', fb: 'Запустить первый фокус', d: 'onb_a_focus_d', fbD: '25 минут на любое дело', tab: 'goals' },
              sel.has('body') && { icon: '🩺', k: 'onb_a_body', fb: 'Отметить самочувствие', d: 'onb_a_body_d', fbD: 'Сон и состояние — 10 секунд', tab: 'body' },
              { icon: '📝', k: 'onb_a_note', fb: 'Записать первую заметку', d: 'onb_a_note_d', fbD: 'Мысль, план или список', tab: 'mine' },
            ].filter(Boolean).map(a => (
              <button key={a.k} onClick={() => finish(a.tab)}
                      style={{ ...btn, display: 'flex', alignItems: 'center', gap: 12, textAlign: 'left', marginBottom: 8, background: CARD, border: `1px solid ${BORDER}` }}>
                <span style={{ fontSize: 20 }}>{a.icon}</span>
                <span style={{ flex: 1 }}>
                  <div style={{ fontSize: 14, color: 'var(--app-text,#ece6d6)' }}>{t(a.k, a.fb)}</div>
                  <div style={{ fontSize: 11, color: 'var(--app-dim,#8a8a92)', fontWeight: 400 }}>{t(a.d, a.fbD)}</div>
                </span>
                <span style={{ color: ACC }}>→</span>
              </button>
            ))}
            <button onClick={() => finish(null)} style={ghost}>{t('onb_skip', 'Позже — просто осмотрюсь')}</button>
          </div>
        )}
      </div>
    </div>
  );
}
